<template>
  <v-dialog :model-value="modelValue" max-width="40%" max-height="80vh" @update:model-value="$emit('update:modelValue', $event)">
    <v-card style="height: 80vh; display: flex; flex-direction: column; padding: 0;">
      <v-card-title class="text-h6 pa-3">参数详情</v-card-title>
      <v-divider class="ma-0"></v-divider>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <v-alert v-else-if="error" type="error" class="ma-2">
        {{ error }}
      </v-alert>
      <v-card-text v-else class="pa-2 flex-grow-1 overflow-auto m-0">
        <v-expansion-panels>
          <!-- 基本信息面板 -->
          <v-expansion-panel>
            <v-expansion-panel-content>
              <v-container class="pa-0">
                <!-- 参数(params) -->
                <v-card class="mb-4 border-0 shadow-sm">
                  <v-card-title @click="showParams = !showParams" class="cursor-pointer flex justify-between items-center">
                    <span class="font-medium">原始参数</span>
                    <v-icon>{{ showParams ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-card-title>
                  <v-card-text v-if="showParams" class="pa-3 pt-0">
                    <pre class="text-base m-0 whitespace-pre-wrap bg-gray-50 p-3 rounded">{{ JSON.parse(detail.params) }}</pre>
                  </v-card-text>
                </v-card>

                <!-- MCP数据(mcpData) -->
                <v-card class="border-0 shadow-sm">
                  <v-card-title @click="showMcpData = !showMcpData" class="cursor-pointer flex justify-between items-center">
                    <span class="font-medium">MCP参数</span>
                    <v-icon>{{ showMcpData ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-card-title>
                  <v-card-text v-if="showMcpData" class="pa-3 pt-0">
                    <pre class="text-base m-0 whitespace-pre-wrap bg-gray-50 p-3 rounded">{{ JSON.parse(detail.mcpData) }}</pre>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="pa-2 justify-end">
        <v-btn color="primary" @click="$emit('update:modelValue', false)">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  detail: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  error: { type: String, default: null }
})
defineEmits(['update:modelValue'])

const showParams = ref(false)
const showMcpData = ref(false)

// 每次打开时折叠所有面板
watch(() => props.modelValue, (open) => {
  if (open) {
    showParams.value = false
    showMcpData.value = false
  }
})
</script>
